import Swiper from 'swiper/bundle'

// import Swiper and modules styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

// init Swiper:
const swiper = new Swiper('.swiper-reviews', {
	autoplay: true,
	breakpoints: {
		640: {
			slidesPerView: 1,
			spaceBetween: 20
		},
		768: {
			slidesPerView: 1,
			spaceBetween: 20
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 20
		}
	}
})
